import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, find, findIndex } from 'lodash';
import { connect } from 'react-redux';
import { addItem, getCartSize } from '../../actions/CartActions';
import { showModal } from '../../actions/ModalActions';
import RegistryGrid from './RegistryGrid';
import RegistryList from './RegistryList';
import { trackProductAdded } from '../../util/trackingHelper';

class RegistryProducts extends Component {
  constructor(props) {
    super(props);

    this.addToCart = this.addToCart.bind(this);
    this.handleToggleGridReveal = this.handleToggleGridReveal.bind(this);

    this.state = {
      fullGrid: !window.optimizelyTeaseRegistryView,
    };
  }

  componentDidMount() {
    this.excludeFromRegistryTease();
  }

  getCollectionWithDefaultGiftCard(collectionToUpdate) {
    const { defaultGiftCard } = this.props;
    if (!defaultGiftCard) return collectionToUpdate;

    const collection = cloneDeep(collectionToUpdate);
    let index = findIndex(
      collection,
      item => (item.contributions && (item.contributions.show_as_fulfilled || item.contributions.show_as_reserved)) || (item.actions && !item.actions.purchase)
    );
    // if there's no unavailble for purchase items, place it in the end of the collection
    if (index < 0) {
      index = collection.length;
    }
    defaultGiftCard.button_cta = 'Choose Amount';
    defaultGiftCard.detail_items = [];
    collection.splice(index, 0, defaultGiftCard);
    return collection;
  }

  /**
   * Creates payload object for custom event from product and supplemental data
   * @param {Object} product - registry collection item
   * @param {Number} quantity - amount of a product
   * @param {String} cartId - cart id to which product is being added to.
   * @returns {Object} - complete payload for custom event tracking
   */
  buildCustomEventData(product, quantity, cartId) {
    const { registryId } = this.props;
    const { name, price } = product;
    const imageUrl = product.images[0].medium;
    const sku = product.sku_object_id;
    const productId = product.product_id;
    const productLookId = product.product_look_id;
    const brand = product.brand && product.brand.name;
    return {
      cart_id: cartId,
      registry_id: registryId,
      product_id: productId,
      sku,
      name,
      brand,
      price,
      quantity,
      image_url: imageUrl,
      variant: productLookId,
      location: 'WEDDING_WEBSITE',
      section: 'QUICK_ADD'
    };
  }

  addToCart(collectionItem, quantity) {
    const { onAddToCart, onCartSize } = this.props;
    const isGroupGift = collectionItem.contributions.group_gift;

    let addToCartRequest;
    if (isGroupGift) {
      addToCartRequest = {
        skuId: collectionItem.sku_object_id,
        collectionItemId: collectionItem.object_id,
        contribution: quantity,
        itemOrigin: 'WEDDINGS'
      };
    } else {
      addToCartRequest = {
        skuId: collectionItem.sku_object_id,
        collectionItemId: collectionItem.object_id,
        quantity,
        itemOrigin: 'WEDDINGS'
      };
    }

    return onAddToCart(addToCartRequest).then((response) => {
      if (!response) return;
      const { cartId } = response.data;
      const eventData = this.buildCustomEventData(collectionItem, quantity, cartId);
      trackProductAdded(eventData);
      // Launch web-nav cart modal
      window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
      onCartSize();
    });
  }

  handleToggleGridReveal() {
    this.setState(prevState => ({
      fullGrid: !prevState.fullGrid
    }));
  }

  excludeFromRegistryTease() {
    // prevent registries with custom collections from seeing this feature
    const { enableCustomCollections, registryCollections } = this.props;
    if (enableCustomCollections && registryCollections.otherCollections && registryCollections.otherCollections.length > 0) {
      this.setState({ fullGrid: true });
    }
  }

  render() {
    const { registryCollections, onShowProduct, view, enableCustomCollections, optimizelyTeaseRegistryView } = this.props;
    const isFilteredByCollection = registryCollections.selectedCollectionObjectId && registryCollections.defaultCollection.length === 0;
    let { defaultCollection } = registryCollections;
    let filteredCollection = [];

    // if filtered by collection e.g. Kitchen, insert default card in that collection
    if (isFilteredByCollection && registryCollections.otherCollections) {
      const collectionToUpdate = registryCollections.otherCollections[0].registry_collection_items;
      filteredCollection = this.getCollectionWithDefaultGiftCard(collectionToUpdate) || [];
    } else {
      defaultCollection = this.getCollectionWithDefaultGiftCard(defaultCollection) || [];
    }

    return (
      <div>
        {view === 'grid' ? (
          <div>
            <RegistryGrid
              collectionItems={defaultCollection}
              collection={find(registryCollections.collectionList, collection => collection && collection.object_id === registryCollections.selectedCollectionObjectId)}
              handleToggleGridReveal={this.handleToggleGridReveal}
              onAddToCart={this.addToCart}
              onShowProduct={onShowProduct}
              enableCustomCollections={enableCustomCollections}
              optimizelyTeaseRegistryView={optimizelyTeaseRegistryView}
              showFullGrid={this.state.fullGrid}
            />
            {isFilteredByCollection && (
              <RegistryGrid
                collection={registryCollections.otherCollections[0]}
                collectionItems={filteredCollection}
                handleToggleGridReveal={this.handleToggleGridReveal}
                onAddToCart={this.addToCart}
                onShowProduct={onShowProduct}
                enableCustomCollections={enableCustomCollections}
                optimizelyTeaseRegistryView={optimizelyTeaseRegistryView}
                showFullGrid={this.state.fullGrid}
              />
            )}

            {!isFilteredByCollection && registryCollections.otherCollections.length > 0 && registryCollections.otherCollections.map(registryCollection => (
              <RegistryGrid
                key={registryCollection.object_id}
                collection={registryCollection}
                collectionItems={registryCollection.registry_collection_items}
                handleToggleGridReveal={this.handleToggleGridReveal}
                onAddToCart={this.addToCart}
                onShowProduct={onShowProduct}
                enableCustomCollections={enableCustomCollections}
                optimizelyTeaseRegistryView={optimizelyTeaseRegistryView}
                showFullGrid={this.state.fullGrid}
              />
            ))}
          </div>
        ) : (
          <div>
            <RegistryList
              collectionItems={defaultCollection}
              onAddToCart={this.addToCart}
              onShowProduct={onShowProduct}
            />
            {registryCollections.otherCollections.length > 0 && registryCollections.otherCollections.map(registryCollection => (
              <RegistryList
                key={registryCollection.object_id}
                collection={registryCollection}
                collectionItems={registryCollection.registry_collection_items}
                onAddToCart={this.addToCart}
                onShowProduct={onShowProduct}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

RegistryProducts.propTypes = {
  defaultGiftCard: PropTypes.shape({}),
  view: PropTypes.string,
  registryCollections: PropTypes.shape({}),
  registryId: PropTypes.string.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  onCartSize: PropTypes.func.isRequired,
  enableCustomCollections: PropTypes.bool,
  optimizelyTeaseRegistryView: PropTypes.bool,
};

const mapStateToProps = state => (
  {
    registryCollections: state.registryCollections,
    registryId: state.registry.registry_object_id || state.publicWebsite.zolaRegistry.registry_object_id,
  }
);

const mapDispatchToProps = dispatch => (
  {
    onAddToCart: addToCartRequest => dispatch(addItem(addToCartRequest)),
    onShowProduct: (collectionItem, isDefaultGiftCard) => dispatch(showModal('REGISTRY_ITEM', { collectionItem, isDefaultGiftCard }, { size: 'xl' })),
    onCartSize: () => dispatch(getCartSize()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistryProducts);



// WEBPACK FOOTER //
// ./src/components/registry/RegistryProducts.jsx